import { LengthItemMetadataBase } from "./length-item-metadata.model"


export class ValueItemMetadataBase extends LengthItemMetadataBase {

    value: string = "none"

    constructor(type: string) {
        super(type)
    }

}

export interface ValueItemMetadata extends ValueItemMetadataBase { }